/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

import type {
  EntWebsiteAcademyModuleFragment,
  EntWebsiteBenefitListFragment,
  EntWebsiteCaseStudyFragment,
  EntWebsiteCerosWidgetFragment,
  EntWebsiteComparePlansFragment,
  EntWebsiteContactSalesFragment,
  EntWebsiteContentFragment,
  EntWebsiteCourseSearchWidgetFragment,
  EntWebsiteCtaFragment,
  EntWebsiteFaqFragment,
  EntWebsiteFeaturedContentFragment,
  EntWebsiteHowFragment,
  EntWebsiteInsightsFragment,
  EntWebsiteLeaderListFragment,
  EntWebsiteMarketoModuleFragment,
  EntWebsiteNativeFragment,
  EntWebsitePartnerListFragment,
  EntWebsitePdfViewerFragment,
  EntWebsiteProspectNavFragment,
  EntWebsiteResourceHubCollectionWithSearchFragment,
  EntWebsiteResourceHubFragment,
  EntWebsiteSkillsetsFragment,
  EntWebsiteTabsFragment,
  EntWebsiteTestimonialCarouselFragment,
  EntWebsiteTestimonialFragment,
  EntWebsiteTwoColumnsFragment,
  EntWebsiteUpcomingEventsFragment,
  EntWebsiteValuePropFragment,
  EntWebsiteWhyFragment,
  EnterpriseArticleFragment,
} from 'bundles/ent-website/__generated__/contentfulTypes';
import { eventingTransform } from 'bundles/ent-website/utils/eventingTransform';
import TrackedDiv from 'bundles/page/components/TrackedDiv';

export type BlockLevelModule =
  | EntWebsiteAcademyModuleFragment
  | EntWebsiteBenefitListFragment
  | EntWebsiteCaseStudyFragment
  | EntWebsiteComparePlansFragment
  | EntWebsiteContactSalesFragment
  | EntWebsiteContentFragment
  | EntWebsiteCtaFragment
  | EntWebsiteHowFragment
  | EntWebsiteFaqFragment
  | EntWebsiteLeaderListFragment
  | EntWebsiteMarketoModuleFragment
  | EntWebsitePartnerListFragment
  | EntWebsiteSkillsetsFragment
  | EntWebsiteTestimonialFragment
  | EntWebsiteTestimonialCarouselFragment
  | EntWebsiteWhyFragment
  | EntWebsiteValuePropFragment
  | EntWebsiteProspectNavFragment
  | EntWebsiteResourceHubFragment
  | EntWebsiteCourseSearchWidgetFragment
  | EntWebsiteCerosWidgetFragment
  | EntWebsitePdfViewerFragment
  | EntWebsiteInsightsFragment
  | EntWebsiteTwoColumnsFragment
  | EntWebsiteUpcomingEventsFragment
  | EntWebsiteFeaturedContentFragment
  | EntWebsiteResourceHubCollectionWithSearchFragment
  | EntWebsiteNativeFragment
  | EnterpriseArticleFragment
  | EntWebsiteTabsFragment;

type Props = {
  content: BlockLevelModule;
};

const Module: React.FC<Props> = ({ children, content }) => {
  const trackingName = eventingTransform(`${content?.__typename}_${content?.slug}`);

  return (
    <TrackedDiv trackingName={trackingName} withVisibilityTracking trackMouseEnters trackMouseLeaves trackClicks>
      {children}
    </TrackedDiv>
  );
};

export default Module;
